import { STATUS_LABELS } from '@/shared/config/constants';
import { status as STATUS_COLORS, typography, radius } from '@/shared/theme/tokens';

export function StatusBadge({ status }) {
  const color = STATUS_COLORS[status] ?? STATUS_COLORS.inactive;
  const label = STATUS_LABELS[status] ?? status;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      padding: '3px 9px',
      borderRadius: radius.full,
      background: color.bg,
      border: `1px solid ${color.border}`,
      fontSize: typography.fontSize.sm,
      fontWeight: typography.fontWeight.semibold,
      color: color.text,
      letterSpacing: typography.letterSpacing.wide,
      whiteSpace: 'nowrap',
    }}>
      <span style={{
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        background: color.text,
        flexShrink: 0,
      }} />
      {label}
    </span>
  );
}
